import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PiecesService } from 'app/services/pieces/pieces.service';

@Component({
  selector: 'app-liste-pieces',
  templateUrl: './liste-pieces.component.html',
  styleUrls: ['./liste-pieces.component.scss']
})
export class ListePiecesComponent implements OnInit {
  
  public search: string  = ''

  dataSource = new MatTableDataSource();
  Pieces:any
  constructor(private piecesService:PiecesService) { }

  getData() {
    this.piecesService.getListPiece().subscribe((data) => {
      this.Pieces = data;
      console.log('this is my data ',data)
    });
  }
  ngOnInit() {
    this.piecesService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }
  deletePiece(pieceProduit: any) {
    this.piecesService.deletePiece(pieceProduit.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
    setTimeout(() => {
      this.getData()
    }, 500)

  }

}
